var e = /* @__PURE__ */ ((t) => (t.MEDIA = "media", t.TEXT = "text", t.QUESTION = "question", t.SEPERATOR = "seperator", t.EMBEDDED = "embedded", t))(e || {}), a = /* @__PURE__ */ ((t) => (t.YES_NO = "yes_no", t.TRUE_FALSE = "true_false", t.SINGLE_SELECT = "single_select", t.MULTI_SELECT = "multi_select", t.LINEAR_SCALE = "linear_scale", t.SHORT_TEXT = "short_text", t.LONG_TEXT = "long_text", t))(a || {}), l = /* @__PURE__ */ ((t) => (t.IMAGE = "image", t.VIDEO = "video", t.YOUTUBE = "youtube", t.UNKNOWN = "unknown", t))(l || {}), i = /* @__PURE__ */ ((t) => (t.TEXT_ONLY = "text_only", t.TEXT_WITH_IMAGE = "text_with_image", t.TEXT_ON_BACKGROUND_IMAGE = "text_on_background_image", t))(i || {});
const D = {
  text_only: "Text only",
  text_with_image: "Text with image",
  text_on_background_image: "Text on background image"
}, E = {
  yes_no: "Yes/No",
  true_false: "True/False",
  single_select: "Single - select",
  multi_select: "Multi - select",
  linear_scale: "Linear scale",
  short_text: "Short text",
  long_text: "Long text"
}, v = {
  yes_no: [
    { value: "Yes", isCorrect: !0 },
    { value: "No", isCorrect: !1 }
  ],
  true_false: [
    { value: "True", isCorrect: !0 },
    { value: "False", isCorrect: !1 }
  ],
  single_select: [
    { value: "Single Option 1", isCorrect: !0 },
    { value: "Single Option 2", isCorrect: !1 },
    { value: "Single Option 3", isCorrect: !1 },
    { value: "Single Option 4", isCorrect: !1 }
  ],
  multi_select: [
    { value: "Multi Option 1", isCorrect: !0 },
    { value: "Multi Option 2", isCorrect: !0 },
    { value: "Multi Option 3", isCorrect: !1 },
    { value: "Multi Option 4", isCorrect: !1 }
  ]
};
var n = /* @__PURE__ */ ((t) => (t.FULL_WIDTH = "full_width", t.STANDARD = "standard", t.CAROUSEL = "carousel", t))(n || {});
const d = {
  full_width: "Full Width",
  standard: "Standard",
  carousel: "Carousel"
};
var s = /* @__PURE__ */ ((t) => (t.MARKING = "marking", t.AWAIT_MARKING = "await_marking", t.SUBMISSION = "submission", t.RESULTS_SUBMITTED = "results_submitted", t))(s || {}), o = /* @__PURE__ */ ((t) => (t.ShowNewFormDialog = "showNewFormDialog", t.HideNewFormDialog = "hideNewFormDialog", t.SetActivePanel = "setActivePanel", t.ShowSeparatorBlockDialog = "showSeparatorBlockDialog", t.HideSeparatorBlockDialog = "hideSeparatorBlockDialog", t.SetActiveBlock = "setActiveBlock", t.ShowMediaBlockTemplateDialog = "showMediaBlockTemplateDialog", t.HideMediaBlockTemplateDialog = "hideMediaBlockTemplateDialog", t.ShowTextBlockTemplateDialog = "showTextBlockTemplateDialog", t.HideTextBlockTemplateDialog = "hideTextBlockTemplateDialog", t.ShowFormSubmissionPreviewDialog = "showFormSubmissionPreviewDialog", t.HideFormSubmissionPreviewDialog = "hideFormSubmissionPreviewDialog", t.ShowAddYoutubeLinkDialog = "showAddYoutubeLinkDialog", t.HideAddLinkDialog = "hideAddLinkDialog", t.SetDirtyPanels = "setDityPanels", t.ResetDirtyPanels = "resetDirtyPanels", t.TouchAllPanels = "touchAllPanels", t.InitActivePanel = "initActivePanel", t.ShowAddEmbeddedLinkDialog = "showAddEmbeddedLinkDialog", t.HideAddEmbeddedLinkDialog = "hideAddEmbeddedLinkDialog", t))(o || {}), r = /* @__PURE__ */ ((t) => (t.StartPanelSubmitting = "startPanelSubmitting", t.EndPanelSubmitting = "endPanelSubmitting", t.SetFormSubmissionStatus = "setFormSubmissionStatus", t.SetDirtyPanels = "setDirtyPanels", t.SetPanelCompletionAlert = "setPanelCompletionAlert", t.ResetState = "resetState", t.SetPanelStatus = "setPanelStatus", t))(r || {}), S = /* @__PURE__ */ ((t) => (t.V2 = "v2", t))(S || {}), g = /* @__PURE__ */ ((t) => (t.LMS = "lms", t.STANDARD = "standard", t))(g || {}), u = /* @__PURE__ */ ((t) => (t.BLOCK = "block", t.BADGE = "badge", t))(u || {}), _ = /* @__PURE__ */ ((t) => (t.INITIAL = "initial", t.PENDING = "pending", t.MARKS_SUBMITTED = "marks-submitted", t.REQUEST_RESUBMIT = "request-resubmit", t))(_ || {});
export {
  e as BlockType,
  v as DefaultAnswerOptions,
  o as FormBuilderActionTypes,
  S as FormBuilderVersion,
  r as FormRendererActionTypes,
  s as FormRendererModes,
  _ as FormSubmissionStatusType,
  g as FormType,
  n as MediaBlockTemplate,
  d as MediaBlockTemplateLabels,
  l as MediaType,
  E as QuestionTypeLabels,
  a as QuestionTypes,
  u as SelectedMedia,
  i as TextBlockTemplate,
  D as TextBlockTemplateLabels
};
